import { render } from "./ServiceList.vue?vue&type=template&id=5e5ad047"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"

import "./ServiceList.vue?vue&type=style&index=0&id=5e5ad047&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__